import commonMapping from "@/mapping/common";

export const backup = {
    upgrade_enable: commonMapping.intToBoolean,
};

export default backup;
